<template>
  <kst-container class="kst-client-list">
    <kst-form :failureInit="failureInit" :loading="isLoading" :title="title">
      <template #top-right>
        <kst-button action-mode full-label
          class="is-primary"
          :module="Model.Module"
          :moduleType="Model.ModuleType.New"
        />
      </template>

      <kst-section search-mode class="pb-0">
        <Search
          :searchData="searchData"
          @reset="handleSearcReset"
          @submit="handleSearchSubmit"
        />
      </kst-section>

      <kst-section search-result-mode>
        <template #top-right>
          <kst-button action-mode
            class="is-primary mr-4"
            :module="Model.Module"
            :moduleType="Model.ModuleType.Print"
          />
          <kst-button action-mode
            class="is-primary"
            tag="button"
            :module="Model.Module"
            :moduleType="Model.ModuleType.ExportList"
            @click="handleExport"
          />
        </template>

        <Export
        ref="refExport"
        :items="items"
        /> 

        <List :failureList="failureList" :items="items" :isListLoading="isListLoading"/>
      </kst-section>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import Model from "../ClientModel.js";

import Search from "./ClientList_Search";
import List from "./ClientList_List";
import Services from "../ClientServices.js";
import Export from "./ClientList_Export";

export default {
  mixins: [AxiosMixin],
  components: {
    Search,
    List,
    Export
  },
  data: () => ({
    Model: Model,
    searchData: null,
    items: [],
    isLoading: false,
    isListLoading: true,
    // support debounce
    loadCounter: 0,
    // error
    failureInit: null,
    failureList: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initSearch();
      this.loadData(this.loadCounter, this.searchData);
    },
    initSearch() {
      this.searchData = {
        Search: ""
      };
    },

    loadData(counter, searchData) {
      this.isListLoading = true;
      let options = { active: '' };
      if (searchData) {
        options.name = this.$kst.Out.getString(searchData.Search);
        options.field = Model.Search.Fields;
      }

      this.failureInit = null;
      const config = Services.getClientList(options);
      this.runAxios(config, counter, this.loadData_Success, this.loadData_Error);
    },

    loadData_Success(data, counter) {
      // handle repeated execution on slow network to show last request
      if (counter !== this.loadCounter) {
        return;
      }
      this.items = data;
      this.isLoading = false;
      this.isListLoading = false;
    },
    loadData_Error(message) {
      this.failureList = message;
      this.isLoading = false;
    },

    handleExport() {
      this.$refs.refExport.exportExcel();
    },

    handleSearchSubmit() {
      this.loadCounter++;
      this.loadData(this.loadCounter, this.searchData);
    },
    handleSearcReset() {
      this.initSearch();
      this.loadCounter++;
      this.loadData(this.loadCounter, this.searchData);
    }
  }
}
</script>